import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import * as Icons from '@mui/icons-material';
import Typography from '@mui/material/Typography'

// 🔧 Icon rendering helper
function DynamicIcon({ iconName, iconStyle = {} }) {
    const IconComponent = Icons[iconName];
    return IconComponent ? <IconComponent sx={iconStyle} /> : null;
}

export default function Save({ widgetStyle = {}, widgetProps = {} }) {
    const {
        containerStyle,
        // Image Start
        imageStyle,
        // Image End

        // Header Start
        headerStyle,
        // Header End

        // Description Start
        descriptionStyle,
        // Description End
        
        //Button Start
        buttonStyle
        //Button End
    } = widgetStyle;
    const { 
            spacing,
            justifyContent,
            alignItems,
        /* Image*/
            imageUrl,

        /* Header*/
            header,
    
        /* Description*/
            description,

        /* Button Start*/
            buttonText ,
            href, 
            startIcon, 
            startIconName = 'Favorite', 
            endIcon, 
            endIconName = 'Favorite', 
            iconStyle = {}, 
        //Button End
    } = widgetProps;

    return (
        <Grid container spacing={parseInt(spacing) ?? {lg: 0, md: 0, sm: 0, xs: 0}} sx={[containerStyle ?? {}]} justifyContent={justifyContent ?? {xl: 'unset', lg: 'unset', md: 'unset', sm: 'unset', xs: 'unset'}} alignItems={alignItems ?? {xl: 'unset', lg: 'unset', md: 'unset', sm: 'unset', xs: 'unset'}}>
            <Grid size={6} sx={[imageStyle ?? {}]}>
                <Box width={1} height={1} component={'img'} src={imageUrl ?? 'https://hyper-active.com/assets/images/logo.png'} />
            </Grid>
            <Grid size={6}>
                <Typography sx={[headerStyle ?? {}]}>{header ?? 'Lorem ipsum dolor sit amet consectetur adipisicing elit.'}</Typography>
                <Typography sx={[descriptionStyle ?? {}]}>{description ?? 'Lorem ipsum dolor sit amet consectetur adipisicing elit.'}</Typography>
                { 
                    buttonText && 
                    <Button 
                        variant='contained'
                        sx={[buttonStyle ?? {}]}
                        {...(href && !window.location.href.includes('/cms') ? { LinkComponent: Link, to: href } : {})}
                        startIcon={startIcon ? <DynamicIcon iconName={startIconName} iconStyle={iconStyle} /> : undefined}
                        endIcon={endIcon ? <DynamicIcon iconName={endIconName} iconStyle={iconStyle} /> : undefined}
                    >
                        {buttonText}
                    </Button> 
                }
            </Grid>
        </Grid>
    )
}